import { RadioGroup } from 'cdk-radial';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { formatCurrency } from 'utils/formatCurrency';
import { labels } from './messages';
import {
  StyledPrintCheckDialogContent,
  StyledPrintCheckLabel,
  StyledPrintCheckValue,
  StyledPrintOrderDiv
} from './styled';
import { DialogContentType } from './types';

export const DialogContent: FC<DialogContentType> = ({
  paymentDate,
  totalAmount,
  handleOptionSelect,
  printOrder,
  radioOptions,
  printerName
}) => {
  const intl = useIntl();

  return (
    <>
      <StyledPrintCheckDialogContent>
        <StyledPrintCheckLabel>
          {intl.formatMessage(labels.paymentDateLabel)}
        </StyledPrintCheckLabel>
        <StyledPrintCheckValue>{paymentDate}</StyledPrintCheckValue>
        <StyledPrintCheckLabel>
          {intl.formatMessage(labels.totalLabel)}
        </StyledPrintCheckLabel>
        <StyledPrintCheckValue>
          {formatCurrency(totalAmount)}
        </StyledPrintCheckValue>
      </StyledPrintCheckDialogContent>
      <StyledPrintOrderDiv>
        <StyledPrintCheckLabel>
          {intl.formatMessage(labels.printOrderLabel)}
        </StyledPrintCheckLabel>
        <RadioGroup
          className="radioGroup"
          name="printOrder"
          onChange={handleOptionSelect}
          options={radioOptions}
          value={printOrder}
        />
      </StyledPrintOrderDiv>
      <StyledPrintCheckLabel>
        {intl.formatMessage(labels.printerNumberLabel)}
      </StyledPrintCheckLabel>
      <StyledPrintCheckValue>{printerName}</StyledPrintCheckValue>
    </>
  );
};
